import { IState } from "./iState";

export const initialState: IState = {
  user: undefined,
  isAuth: false
};